'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeStyles = require('../../../Styles/makeStyles.js');

var CONTAINER_WIDTH = 120;
var CONTAINER_HEIGHT = 48;
var DEFAULT_CENTER_POINT = CONTAINER_WIDTH / 2;

var getTargetLineLeftPosition = function getTargetLineLeftPosition(value) {
  return "calc(".concat(value, "% - ").concat(DEFAULT_CENTER_POINT, "px)");
};

var useStyles = makeStyles["default"](function (theme) {
  return {
    line: {
      height: CONTAINER_HEIGHT / 2,
      width: 5,
      background: theme.palette.common.black,
      borderRadius: 2,
      position: 'absolute',
      marginTop: 16
    },
    label: {
      marginTop: -29,
      textAlign: 'center'
    },
    container: function container(_ref) {
      var value = _ref.value;
      return {
        height: CONTAINER_HEIGHT,
        marginTop: -39,
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        placeContent: 'center',
        position: 'absolute',
        width: CONTAINER_WIDTH,
        marginLeft: getTargetLineLeftPosition(value),
        zIndex: 1
      };
    }
  };
});

exports.useStyles = useStyles;
